import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TagContext = /*#__PURE__*/createContext(undefined);
export const TagProvider = ({
  closeButtonStyleOverrides,
  linkStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(TagContext.Provider, {
    value: {
      closeButtonStyleOverrides,
      linkStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `Tag` component.
 * Note: The context is only available when the `Tag` component is rendered as an ancestor.
 * @returns TagContext - The context for the `Tag` component.
 * @returns TagContext.closeButtonStyleOverrides - Style overrides to be applied to the `CloseButton` component.
 * @returns TagContext.linkStyleOverrides - Style overrides to be applied to the `Link` component.
 */
export const useTagContext = () => {
  const tagContext = useContext(TagContext);
  return tagContext;
};